import { render } from "./AssetPage.vue?vue&type=template&id=5541e20e&scoped=true"
import script from "./AssetPage.vue?vue&type=script&lang=js"
export * from "./AssetPage.vue?vue&type=script&lang=js"

import "./AssetPage.vue?vue&type=style&index=0&id=5541e20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5541e20e"]])

export default __exports__